import axios from 'axios';
import Segment from '../entity/segment.entity';

export default class SegmentService {
  static readonly PATH_URL = '/api/v1/segments';

  public static getSegments(): Promise<Segment[]> {
    return axios.get(this.PATH_URL)
      .then((response: any) => Segment.ofList(response.data));
  }

  public static create(segment: Segment): Promise<Segment> {
    return axios
      .post(this.PATH_URL, segment)
      .then((response: any) => Segment.of(response.data));
  }
}
